import * as type from "../types";

const initialState = {
  all: [],
  current: null,
  allContracts: [],
  currentContracts: [],
  selectedSessionContracts: [],
  selectedContract: null,
  loading: false,
  error: false,
  contractDepthBUYList: [],
  contractDepthSELLList: [],
  contractDepthBUYListSmall: [],
  contractDepthSELLListSmall: [],
  contractDepthLoading: false,
  contractDepthError: false,
};

export default function sessions(state = initialState, action) {
  switch (action.type) {
    case type.GET_SESSION_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_SESSION_FAILED:
      return {
        ...state,
        list: [],
        loading: false,
        error: true,
      };
    case type.GET_SESSIONS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_SESSIONS_SUCCEEDED:
      return {
        ...state,
        list: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_SESSIONS_FAILED:
      return {
        ...state,
        list: [],
        loading: false,
        error: true,
      };
    case type.GET_SIMPLIFIED_SESSIONS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_SIMPLIFIED_SESSIONS_SUCCEEDED:
      return {
        ...state,
        list: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_SIMPLIFIED_SESSIONS_FAILED:
      return {
        ...state,
        list: [],
        loading: false,
        error: true,
      };
    case type.GET_CURRENT_SESSIONS_REQUESTED:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case type.GET_CURRENT_SESSIONS_SUCCEEDED:
      return {
        ...state,
        current: action.payload,
        loading: false,
        error: false,
      };
    case type.GET_CURRENT_SESSIONS_FAILED:
      return {
        ...state,
        current: [],
        loading: false,
        error: true,
      };
    case type.SET_CURRENT_CONTRACTS:
      return {
        ...state,
        currentContracts: action.payload,
      };
    case type.REMOVE_CURRENT_CONTRACTS:
      return {
        ...state,
        currentContracts: [],
      };
    case type.SET_SELECTED_SESSION_CONTRACTS:
      return {
        ...state,
        selectedSessionContracts: action.payload,
      };
    case type.SET_CURRENT_CONTRACT_SELECTED:
      return {
        ...state,
        selectedContract: action.payload,
      };
    case type.GET_CONTRACT_DEPTH_REQUESTED:
      return {
        ...state,
        contractDepthLoading: true,
        contractDepthError: false,
      };
    case type.GET_CONTRACT_DEPTH_SUCCEEDED:
      return {
        ...state,
        contractDepthBUYList: action.payload.buy,
        contractDepthSELLList: action.payload.sell,
        contractDepthBUYListSmall: action.payload.buySmall,
        contractDepthSELLListSmall: action.payload.sellSmall,
        contractDepthLoading: false,
        contractDepthError: false,
      };
    case type.GET_CONTRACT_DEPTH_FAILED:
      return {
        ...state,
        contractDepthBUYList: [],
        contractDepthSELLList: [],
        contractDepthLoading: false,
        contractDepthError: true,
      };
    default:
      return state;
  }
}
